/**
 * LivePage — thin dev/test adapter for the kill-switch.
 *
 * Production lives in OperatorHome as an embedded
 * <LiveKillSwitchControl /> (status + inline toggle). This page exists
 * so the /search/settings/live route still resolves for:
 *   1. Dev / manual smoke tests (e.g. toggling without going through Home).
 *   2. The SearchRouter R7 route smoke test (mocks this component).
 *
 * It is intentionally UNSTYLED — no FeaturePageShell, no admin chrome.
 * The page renders <LiveKillSwitchControl showStatus /> directly inside a
 * plain Box; the control owns its own status / switch / refresh UI.
 *
 * Not in searchPageMap. Not in the sidebar. Not in any nav derivation.
 * Direct deep links to /search/settings/live still work because the route
 * is registered in SearchRouter.
 */
import React from 'react';
import { Box } from '@material-ui/core';
import LiveKillSwitchControl from '../../components/admin/LiveKillSwitchControl';

const LivePage = () => (
  <Box className="live-page-body" data-testid="live-page">
    <LiveKillSwitchControl showStatus />
  </Box>
);

export default LivePage;
